import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import { Typography } from 'Components/atoms';
import ComplianceBenchmarksCredentialsModal from './ComplianceBenchmarksCredentialsModal';

const ComplianceBenchmarkConfigCredentials: React.FC<{ cid: string }> = ({ cid }) => {
    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const credentialProps = {
        cid,
        show: open,
        onClose: handleClose,
    };

    return (
        <div className="credentials-config">
            <div>
                <Typography variant="subtitle1">Compliance Benchmarks Credentials</Typography>
                <Typography variant="body2" className="text">
                    Instructions to obtain the credentials for compliance benchmarks can be found{' '}
                    <a
                        href="https://developer.jamf.com/platform-api/reference/getting-started-with-platform-api#credentials"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="link"
                    >
                        here
                    </a>
                    .
                    <br />
                    Impact of changes to the configuration will reflect only after the next sync interval.
                </Typography>
            </div>
            <Button className="button body1 ps-4 pe-4 pt-2 pb-2" onClick={handleOpen}>
                Configure
            </Button>
            {open && <ComplianceBenchmarksCredentialsModal {...credentialProps} />}
        </div>
    );
};

export default ComplianceBenchmarkConfigCredentials;
